import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { TypesSyncRunsPage } from '../../../../../components/TypesSyncRunsPage'

const runsSearchSchema = z.object({
  offset: z.number().int().min(0).optional(),
})

export const Route = createFileRoute('/$org/types/sync/runs/')({
  validateSearch: runsSearchSchema,
  component: TypesSyncRunsPage,
})
